import type { CreateAxiosDefaults } from "axios";
import { env } from "@/env";
import { createClient } from "./generated/client";

export const baseHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const axiosConfig = {
  baseURL: env.apiUrl,
  headers: baseHeaders,
  withCredentials: true,
} satisfies CreateAxiosDefaults;

export const httpClient = createClient(axiosConfig);

httpClient.instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href =
        env.appBasePath != null && env.appBasePath !== "/"
          ? `${env.appBasePath}/auth/logout`
          : "/auth/logout";
    }
    return Promise.reject(error);
  },
);

/* HTTP client without interceptors */
export const authHttpClient = createClient(axiosConfig);
